import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GridApi, ColumnApi, ColDef, GridReadyEvent, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { environment } from 'src/environments/environment';
import { RemittanceEarningReportService, RemittanceEarningFilter } from './remittance-earning-report.service';
import { ProductService } from '../../product-management/product-service';
import { CustomerService } from '../../customers/customer-service';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const { defaultPageSizeArr, defaultPageSize } = environment;

@Component({
    selector: 'app-remittance-earning-report',
  templateUrl: './remittance-earning-report.component.html',
  styleUrls: ['./remittance-earning-report.component.scss']
})
export class RemittanceEarningReportComponent implements OnInit, AfterViewInit {

  @ViewChild('filSearchFromDate') private filSearchFromDate: any;
  @ViewChild('filSearchToDate') private filSearchToDate: any;

  public pageSize: number = defaultPageSize; 
  public pageSizeArr: any = defaultPageSizeArr;
  public permissions: any = '';
  
  public txnId: string = '';
  public walletId: string = '';
  public dateFrom: string = '';
  public dateTo: string = '';
  public sendCurrency: string = '';
  public receiveCurrency: string = '';
  public serviceProviderCode: string = '';
  public customerMobile: string = '';
  public receiveCountry: string = '';

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public rowData: any[] = [];
  public columnDefsCopy: ColDef[] = [];
  public tableSelectedColumn: ColDef[] = [];
  collectionSize: number = 0;
  currentPage: number = 1;
  loading: boolean = false;
  quickFilterShow: boolean = false;
    
  public columnDefs: ColDef[] = [
    { field: 'txnId', headerName: 'Transaction ID', tooltipField: 'txnId', resizable: true, sortable: true, width: 150 },
    { field: 'walletId', headerName: 'Wallet ID', tooltipField: 'walletId', resizable: true, sortable: true, width: 120 },
    { field: 'trxnInitiated', headerName: 'Trxn Initiated', tooltipField: 'trxnInitiated', resizable: true, sortable: true, width: 160,
      valueFormatter: (params) => this.formatDateTime(params.value) },
    { field: 'trxnUpdated', headerName: 'Trxn Updated', tooltipField: 'trxnUpdated', resizable: true, sortable: true, width: 160,
      valueFormatter: (params) => this.formatDateTime(params.value) },
    { field: 'sendCountry', headerName: 'Send Country', tooltipField: 'sendCountry', resizable: true, sortable: true, width: 120 },
    { field: 'sendCurrency', headerName: 'Send Currency', tooltipField: 'sendCurrency', resizable: true, sortable: true, width: 120 },
    { field: 'senderName', headerName: 'Sender Name', tooltipField: 'senderName', resizable: true, sortable: true, width: 200 },
    { field: 'serviceProviderCode', headerName: 'SP Name', tooltipField: 'serviceProviderCode', resizable: true, sortable: true, width: 120 },
    { field: 'receiveCountry', headerName: 'Receive Country', tooltipField: 'receiveCountry', resizable: true, sortable: true, width: 130 },
    { field: 'receiveCurrency', headerName: 'Receive Currency', tooltipField: 'receiveCurrency', resizable: true, sortable: true, width: 130 },
    { field: 'receiverName', headerName: 'Receiver Name', tooltipField: 'receiverName', resizable: true, sortable: true, width: 150 },
    { field: 'receiverBankName', headerName: 'Receiver Bank Name', tooltipField: 'receiverBankName', resizable: true, sortable: true, width: 150 },
    { field: 'receiverAcNumber', headerName: 'Receiver A/c Number', tooltipField: 'receiverAcNumber', resizable: true, sortable: true, width: 180 },
    { field: 'deliveryOption', headerName: 'Delivery Option', tooltipField: 'deliveryOption', resizable: true, sortable: true, width: 130 },
    { field: 'sendAmount', headerName: 'Send Amount', tooltipField: 'sendAmount', resizable: true, sortable: true, width: 120,
      valueFormatter: (params) => params.value != null ? String(params.value) : '' },
    { field: 'offeredFxRate', headerName: 'Offered FX Rate', tooltipField: 'offeredFxRate', resizable: true, sortable: true, width: 130,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'baseFxRate', headerName: 'Base FX Rate', tooltipField: 'baseFxRate', resizable: true, sortable: true, width: 120,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'fxEarningAED', headerName: 'FX Earning AED', tooltipField: 'fxEarningAED', resizable: true, sortable: true, width: 140,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'fee', headerName: 'Fee', tooltipField: 'fee', resizable: true, sortable: true, width: 100,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'vatOnFee', headerName: 'VAT on Fee', tooltipField: 'vatOnFee', resizable: true, sortable: true, width: 120,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'netFee', headerName: 'Net Fee', tooltipField: 'netFee', resizable: true, sortable: true, width: 120,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'spFee', headerName: 'SP Fee', tooltipField: 'spFee', resizable: true, sortable: true, width: 100,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'feeEarning', headerName: 'Fee Earning', tooltipField: 'feeEarning', resizable: true, sortable: true, width: 120,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'totalEarning', headerName: 'Total Earning', tooltipField: 'totalEarning', resizable: true, sortable: true, width: 130,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'discount', headerName: 'Discount', tooltipField: 'discount', resizable: true, sortable: true, width: 100,
      valueFormatter: (params) => params.value != null ? String(params.value) : '0' },
    { field: 'totalAmount', headerName: 'Total Amount', tooltipField: 'totalAmount', resizable: true, sortable: true, width: 120,
      valueFormatter: (params) => params.value ? String(params.value) : '' },
    { field: 'receiveAmount', headerName: 'Receive Amount', tooltipField: 'receiveAmount', resizable: true, sortable: true, width: 140,
      valueFormatter: (params) => params.value ? String(params.value) : '' },
    { field: 'remitterCompanyName', headerName: 'Remitter Company Name', tooltipField: 'remitterCompanyName', resizable: true, sortable: true, width: 200 },
    { field: 'occupation', headerName: 'Occupation', tooltipField: 'occupation', resizable: true, sortable: true, width: 130 },
    { field: 'customerType', headerName: 'Customer Type', tooltipField: 'customerType', resizable: true, sortable: true, width: 130 },
    { field: 'idTypeDetails', headerName: 'ID Type Details', tooltipField: 'idTypeDetails', resizable: true, sortable: true, width: 150 },
    { field: 'additionalDocuments', headerName: 'Additional Documents', tooltipField: 'additionalDocuments', resizable: true, sortable: true, width: 180 },
    { field: 'purpose', headerName: 'Purpose', tooltipField: 'purpose', resizable: true, sortable: true, width: 130 },
    { field: 'relationship', headerName: 'Relationship', tooltipField: 'relationship', resizable: true, sortable: true, width: 130 },
    { field: 'sourceOfFunds', headerName: 'Source of Funds', tooltipField: 'sourceOfFunds', resizable: true, sortable: true, width: 150 }
  ];

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public currencyOptions: string[] = [];
  public spOptions: string[] = [];
  public countryDropDown: any[] = [];

  constructor(
    private menuService: MenusService,
    private location: Location,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private remittanceService: RemittanceEarningReportService,
    private productService: ProductService,
    private customerService: CustomerService,
    private cdr: ChangeDetectorRef,
    private exportTrackingService: ExportTrackingService
  ) {
    this.dateFrom = '';
    this.dateTo = '';
  }

  async ngOnInit(): Promise<void> {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['page_size']) {
        const pageSizeParam = parseInt(params['page_size'], 10);
        if (this.pageSizeArr.includes(pageSizeParam)) {
          this.pageSize = pageSizeParam;
        }
      }
      if (params['page_no'] !== undefined) {
        const pageNoParam = parseInt(params['page_no'], 10);
        if (pageNoParam >= 0) {
          this.currentPage = pageNoParam + 1;
        }
      }
    });

    this.columnDefsCopy = [...this.columnDefs.filter((col) => !col?.hide)];
    this.tableSelectedColumn = [...this.columnDefs.filter((col) => !col?.hide)];
    this.productService.getCountryDropdown().subscribe((response: any) => {
      if (response && response.response && response.response.data) {
        this.countryDropDown = response.response.data;
      }
    }, (error: any) => {
      this.countryDropDown = [];
    });
    
    this.customerService.getCurrencyList().subscribe((response: any) => {
      if (response && response.response && response.response.data) {
        this.currencyOptions = Array.from(
          new Set(response.response.data.map((item: any) => item.currencyCode).filter((code: any) => code))
        ) as string[];
      }
    });

    this.remittanceService.getServiceProviderCodes().subscribe((response: any) => {
      const status = response?.status || response?.response?.status;
      const httpStatus = response?.httpStatus || response?.response?.httpStatus;
      const errorMessage = response?.message || response?.response?.message;
      const data = response?.data || response?.response?.data;
      
      if ((status && status >= 400) || 
          (httpStatus && (httpStatus === 'UNAUTORIZED' || httpStatus === 'UNAUTHORIZED' || httpStatus === 'FORBIDDEN' || httpStatus === 'BAD_REQUEST' || httpStatus === 'INTERNAL_SERVER_ERROR')) ||
          (data === null && errorMessage)) {
        const messageToShow = errorMessage || 'An error occurred while fetching service provider codes.';
        this.alertService.errorAlertWithMessage(messageToShow);
        this.spOptions = [];
        return;
      }
      
      if (response && response.response && response.response.data && Array.isArray(response.response.data)) {
        this.spOptions = response.response.data;
      } else {
        this.spOptions = [];
      }
    }, (error: any) => {
      console.error('Error fetching service provider codes:', error);
      const errorMessage = error?.error?.message || error?.message || 'Failed to fetch service provider codes.';
      this.alertService.errorAlertWithMessage(errorMessage);
      this.spOptions = []; 
    });
    
    this.fetchRemittanceEarningReport();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.gridApi) {
      this.gridApi.paginationSetPageSize(this.pageSize);
    }
  }

  fetchRemittanceEarningReport(): void {
    if (this.gridApi) {
      this.gridApi.applyTransaction({ remove: this.rowData });
      this.gridApi.showLoadingOverlay();
    }
    
    this.loading = true;
    this.cdr.detectChanges();
    
    const filter: RemittanceEarningFilter = {
      productCode: 'CROSS_BORDER_TRANSFER',
      sort_dir: 'DESC',
      sort_column: 'createDate',
      txnStatus: 'SUCCESS',
      page_size: this.pageSize,
      page_no: this.currentPage - 1
    };
    
    this.updateUrlParams();
    
    this.remittanceService.getRemittanceEarningReport(filter).subscribe({
      next: (response: any) => {
        this.handleApiResponse(response);
      },
      error: (error: any) => {
        this.handleApiError(error);
      }
    });
  }

  onSearchPayments(): void {
    this.currentPage = 1;
    
    if (this.gridApi) {
      this.gridApi.applyTransaction({ remove: this.rowData });
      this.gridApi.showLoadingOverlay();
    }
    
    this.loading = true;
    this.cdr.detectChanges();
    
    const filter: RemittanceEarningFilter = this.buildFilter();
    
    this.updateUrlParams();
    
    this.remittanceService.getRemittanceEarningReport(filter).subscribe({
      next: (response: any) => {
        this.handleApiResponse(response);
      },
      error: (error: any) => {
        this.handleApiError(error);
      }
    });
  }

 
  onExportCSV(): void {
    if (this.collectionSize === 0 || !this.rowData || this.rowData.length === 0) {
      this.alertService.errorAlertWithMessage('No data to export. Please search for records first.');
      return;
    }

    this.loading = true;
    this.cdr.detectChanges();

    const expData: any[] = [];
    this.rowData.forEach((curr: any) => {
      const tempRec: any = {};
      this.tableSelectedColumn.forEach((col) => {
        if (col?.field && col?.field !== 'actions') {
          tempRec[col.field] = curr[col.field];
        }
      });
      expData.push(tempRec);
    });

    this.exportAsExcelFile(expData, 'Remittance_Earning_Report');
    this.loading = false;
    this.cdr.detectChanges();
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'REMITTANCE_EARNING_REPORT',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Remittance earning export tracked in audit logs:', response);
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);  
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  private performExcelExport(data: any[], excelFileName: string): void {
    if (!data || data.length === 0) {
      this.alertService.errorAlertWithMessage('No data to export.');
      this.loading = false;
      this.cdr.detectChanges();
      return;
    }

    const today = new Date();
    const referenceId = formatDate(today, 'yyyy-MM-dd_HH-mm-ss', 'en-US');
    const fileName = `${excelFileName}_${referenceId}`;
    
    const exportData = data.map((item: any) => ({
      'Transaction ID': item.txnId || '',
      'Wallet ID': item.walletId || '',
      'Trxn Initiated': this.formatDateTime(item.trxnInitiated),
      'Trxn Updated': this.formatDateTime(item.trxnUpdated),
      'Send Country': item.sendCountry || '',
      'Send Currency': item.sendCurrency || '',
      'Sender Name': item.senderName || '',
      'SP Name': item.serviceProviderCode || '',
      'Receive Country': item.receiveCountry || '',
      'Receive Currency': item.receiveCurrency || '',
      'Receiver Name': item.receiverName || '',
      'Receiver Bank Name': item.receiverBankName || '',
      'Receiver A/c Number': item.receiverAcNumber || '',
      'Delivery Option': item.deliveryOption || '',
      'Send Amount': item.sendAmount || '',
      'Offered FX Rate': item.offeredFxRate != null ? parseFloat(item.offeredFxRate.toString()) : 0,
      'Base FX Rate': item.baseFxRate != null ? parseFloat(item.baseFxRate.toString()) : 0,
      'FX Earning AED': item.fxEarningAED != null ? parseFloat(item.fxEarningAED.toString()) : 0,
      'Fee': item.fee != null ? parseFloat(item.fee.toString()) : 0,
      'VAT on Fee': item.vatOnFee != null ? parseFloat(item.vatOnFee.toString()) : 0,
      'Net Fee': item.netFee != null ? parseFloat(item.netFee.toString()) : 0,
      'SP Fee': item.spFee != null ? parseFloat(item.spFee.toString()) : 0,
      'Fee Earning': item.feeEarning != null ? parseFloat(item.feeEarning.toString()) : 0,
      'Total Earning': item.totalEarning != null ? parseFloat(item.totalEarning.toString()) : 0,
      'Discount': item.discount != null ? parseFloat(item.discount.toString()) : 0,
      'Total Amount': item.totalAmount ? String(item.totalAmount) : '',
      'Receive Amount': item.receiveAmount ? String(item.receiveAmount) : '',
      'Remitter Company Name': item.remitterCompanyName || '',
      'Occupation': item.occupation || '',  
      'Customer Type': item.customerType || '',
      'ID Type Details': item.idTypeDetails || '',
      'Additional Documents': item.additionalDocuments || '',
      'Purpose': item.purpose || '',
      'Relationship': item.relationship || '',
      'Source of Funds': item.sourceOfFunds || ''
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = { 
      Sheets: { 'Remittance Earning Report': worksheet }, 
      SheetNames: ['Remittance Earning Report'] 
    };
    
    const columnWidths = [
      { wch: 18 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 12 },
      { wch: 10 },
      { wch: 12 },
      { wch: 12 },
      { wch: 10 },
      { wch: 12 },
      { wch: 15 },
      { wch: 10 },
      { wch: 12 },
      { wch: 15 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 18 }
    ];
    worksheet['!cols'] = columnWidths;
    
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private getCurrentFilters(): any {
    return {
      txnId: this.txnId || '',
      walletId: this.walletId || '',
      customerMobile: this.customerMobile || '',
      dateFrom: this.dateFrom || '',
      dateTo: this.dateTo || '',
      sendCurrency: this.sendCurrency || '',
      receiveCurrency: this.receiveCurrency || '',
      serviceProviderCode: this.serviceProviderCode || '',
      receiveCountry: this.receiveCountry || '',
      txnStatus: 'SUCCESS'
    };
  }


  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }


  onBackgroundExport(): void {
    this.loading = true;
    this.cdr.detectChanges();

    const filter: RemittanceEarningFilter = this.buildFilter();
    const exportFilter = { ...filter };
    delete exportFilter.page_size;
    delete exportFilter.page_no;

    this.remittanceService.getRemittanceEarningReportBackgroundExport(exportFilter).subscribe(
      (response: any) => {
        this.loading = false;
        this.cdr.detectChanges();
        console.log('Background export response:', response);
        
        if (response?.response?.status === 200) {
          const referenceId = response.response.data[" document referenceId"] || response.response.data.documentReferenceId;
          const recordsCount = response.response.data.recordsCount;
          
          this.alertService.successAlertWithAcknowledgment(
            `Your export of ${recordsCount} records has started. Reference ID: ${referenceId}`
          );
        } else if (response?.response?.status === 509) {
          this.alertService.errorAlertWithMessage(
            `Export limit exceeded: ${response.response.data.message}`
          );
        } else {
          this.alertService.errorAlertWithMessage(
            response?.response?.message || "An error occurred during export. Please try again later."
          );
        }
      },
      error => {
        this.loading = false;
        this.cdr.detectChanges();
        console.error('Background export error:', error);
        
        this.alertService.errorAlertWithMessage(
          error?.response?.message || "Failed to start background export. Please try again later."
        );
      }
    );
  }

  private buildFilter(): RemittanceEarningFilter {
    return {
      productCode: 'CROSS_BORDER_TRANSFER',
      txnStatus: 'SUCCESS',
      sort_dir: 'DESC',
      sort_column: 'createDate',
      txnId: (this.txnId && this.txnId.trim() !== '') ? this.txnId.trim().toUpperCase() : undefined,
      walletId: (this.walletId && this.walletId.trim() !== '') ? this.walletId.trim() : undefined,
      dateFrom: (this.dateFrom && this.dateFrom.trim() !== '') ? this.dateFrom.trim() : undefined,
      dateTo: (this.dateTo && this.dateTo.trim() !== '') ? this.dateTo.trim() : undefined,
      sendCurrency: (this.sendCurrency && this.sendCurrency.trim() !== '') ? this.sendCurrency.trim() : undefined,
      receiveCurrency: (this.receiveCurrency && this.receiveCurrency.trim() !== '') ? this.receiveCurrency.trim() : undefined,
      currency: (this.receiveCurrency && this.receiveCurrency.trim() !== '') ? this.receiveCurrency.trim() : 
                (this.sendCurrency && this.sendCurrency.trim() !== '') ? this.sendCurrency.trim() : undefined,
      serviceProviderCode: (this.serviceProviderCode && this.serviceProviderCode.trim() !== '') ? this.serviceProviderCode.trim() : undefined,
      customerMobile: (this.customerMobile && this.customerMobile.trim() !== '') ? this.customerMobile.trim() : undefined,
      receiveCountry: (this.receiveCountry && this.receiveCountry.trim() !== '') ? this.receiveCountry.trim() : undefined,
      page_size: this.pageSize,
      page_no: this.currentPage - 1
    };
  }


  updateSelectedColumn(event: any): void {
    const columnIndex = parseInt(event.target.value);
    const column = this.columnDefsCopy[columnIndex];
    if (event.target.checked) {
      if (!this.tableSelectedColumn.includes(column)) {
        this.tableSelectedColumn.push(column);
      }
    } else {
      const index = this.tableSelectedColumn.indexOf(column);
      if (index > -1) {
        this.tableSelectedColumn.splice(index, 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn);
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  onPaginationChange(page: number): void {
    if (this.gridApi) {
      this.gridApi.applyTransaction({ remove: this.rowData });
      this.gridApi.showLoadingOverlay();
    }
    
    this.currentPage = page;
    this.updateUrlParams();
    
    this.loading = true;
    this.cdr.detectChanges();
    
    const filter: RemittanceEarningFilter = this.buildFilter();
    
    this.remittanceService.getRemittanceEarningReport(filter).subscribe({
      next: (response: any) => {
        this.handleApiResponse(response);
      },
      error: (error: any) => {
        this.handleApiError(error);
      }
    });
  }

  quickFilterShowAction(event: any): void {
    this.quickFilterShow = !this.quickFilterShow;
  }


  onPageSizeChanges(event: Event): void {
    if (this.gridApi) {
      this.gridApi.paginationSetPageSize(this.pageSize);
      this.gridApi.applyTransaction({ remove: this.rowData });
      this.gridApi.showLoadingOverlay();
    }
    this.currentPage = 1;
    this.updateUrlParams();
    this.onSearchPayments();
  }
  
  Math = Math;

  private formatCurrency(value: number): string {
    if (value === null || value === undefined) return '0.00';
    return parseFloat(value.toString()).toFixed(2);
  }


  private formatDateTime(value: string): string {
    if (!value) return '';
    try {
      const date = new Date(value);
      return formatDate(date, 'dd-MMM-yyyy HH:mm:ss', 'en-US');
    } catch (e) {
      return value;
    }
  }

  getToday(): string {
    return formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  }

  onRowClicked(param: RowClickedEvent): void {
    console.log('Row clicked', param);
  }
  resetFilters(): void {
    this.txnId = '';
    this.walletId = '';
    this.customerMobile = '';
    this.sendCurrency = '';
    this.receiveCurrency = '';
    this.serviceProviderCode = '';
    this.receiveCountry = '';
    this.dateFrom = '';
    this.dateTo = '';
    this.currentPage = 1;
    this.updateUrlParams();
    this.fetchRemittanceEarningReport();
  }


  private updateUrlParams(): void {
    const queryParams: Params = {
      page_size: this.pageSize,
      page_no: this.currentPage - 1, 
      sort_dir: 'DESC',
      sort_column: 'createDate',
      productCode: 'CROSS_BORDER_TRANSFER',
      txnStatus: 'SUCCESS'
    };

    if (this.txnId && this.txnId.trim() !== '') {
      queryParams['txnId'] = this.txnId.trim().toUpperCase();
    }
    if (this.walletId && this.walletId.trim() !== '') {
      queryParams['walletId'] = this.walletId.trim().toUpperCase();
    }
    if (this.customerMobile && this.customerMobile.trim() !== '') {
      queryParams['customerMobile'] = this.customerMobile.trim();
    }
    if (this.dateFrom && this.dateFrom.trim() !== '') {
      queryParams['dateFrom'] = this.dateFrom.trim();
    }
    if (this.dateTo && this.dateTo.trim() !== '') {
      queryParams['dateTo'] = this.dateTo.trim();
    }
    if (this.sendCurrency && this.sendCurrency.trim() !== '') {
      queryParams['sendCurrency'] = this.sendCurrency.trim();
    }
    if (this.receiveCurrency && this.receiveCurrency.trim() !== '') {
      queryParams['receiveCurrency'] = this.receiveCurrency.trim();
    }
    if (this.serviceProviderCode && this.serviceProviderCode.trim() !== '') {
      queryParams['serviceProviderCode'] = this.serviceProviderCode.trim();
    }
    if (this.receiveCountry && this.receiveCountry.trim() !== '') {
      queryParams['receiveCountry'] = this.receiveCountry.trim();
    }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: false 
    });
  }

  private handleApiResponse(response: any): void {
    const status = response?.status || response?.response?.status;
    const httpStatus = response?.httpStatus || response?.response?.httpStatus;
    const errorMessage = response?.message || response?.response?.message;
    const data = response?.data || response?.response?.data;
    
    if ((status && status >= 400) || 
        (httpStatus && (httpStatus === 'UNAUTORIZED' || httpStatus === 'UNAUTHORIZED' || httpStatus === 'FORBIDDEN' || httpStatus === 'BAD_REQUEST' || httpStatus === 'INTERNAL_SERVER_ERROR')) ||
        (data === null && errorMessage)) {
      this.rowData = [];
      this.collectionSize = 0;
      this.updateGridData();
      const messageToShow = errorMessage || 'Unable to fetch data. Please try again later.';
      this.alertService.errorAlertWithMessage(messageToShow);
      return;
    }
    
    let dataSection = null;
    
    if (response?.response?.data) {
      dataSection = response.response.data;
    } else if (response?.data) {
      dataSection = response.data;
    } else if (Array.isArray(response)) {
      this.rowData = response.map((record: any) => 
        this.remittanceService.mapApiResponseToComponentData(record)
      );
      this.collectionSize = response.length;
      this.updateGridData();
      return;
    }
    
    if (!dataSection) {
      this.rowData = [];
      this.collectionSize = 0;
      this.updateGridData();
      this.alertService.errorAlertWithMessage(errorMessage || 'Unable to fetch data. Please try again later.');
      return;
    }

    const content = dataSection?.content || [];
    const totalElements = dataSection?.totalElements || 0;
    
    this.rowData = content.map((record: any) => 
      this.remittanceService.mapApiResponseToComponentData(record)
    );
    
    this.collectionSize = totalElements;
    this.cdr.detectChanges();
    
    this.updateGridData();
  }


  private updateGridData(): void {
    if (this.gridApi) {
      this.gridApi.hideOverlay();
    }
    this.loading = false;
    this.cdr.detectChanges();
  }


  private handleApiError(error: any): void {
    if (this.gridApi) {
      this.gridApi.hideOverlay();
    }
    this.loading = false;
    this.cdr.detectChanges();
    const errorMessage = error?.error?.message || error?.message || 'Failed to fetch remittance earning report. Please try again.';
    this.alertService.errorAlert({
      title: errorMessage,
      backdrop: true,
      toast: true,
      timer: 3000
    });
  }
}
